import React from "react";
import SentPageSvg from "../../assests/sentPageImg.png";
import Text from "../../assests/SentPageBelow.png";
import img from "../../assests/Images/formPage.png";


const SentPage = () => {
  return (
    <div className="flex w-[100vw] h-[84vh] justify-center items-center">
      <div className="bg-white my-[150px] min-h-[600px] relative flex flex-col items-center p-8 shadow-lg rounded-[10px]">
        <h2 className="text-[24px]" style={{ fontFamily: "ZapfHumanistBold" }}>Your designs are on there way!</h2>
        <div className="flex flex-col items-center text-[14px] mt-2">
          <p>
            Please allow a few minutes for the PDF file to reach your inbox from
          <span style={{ fontFamily: "ZapfHumanistBold" }} className="text-black">
            {" "}contact@parifypackaging.co.uk
          </span>
          </p>
          <p>
            <span className="text-red-500"> If there is no sign of the file, even in your junk items,</span>
            {" "} please
            contact us{" "}
            <b style={{ fontFamily: "ZapfHumanistBold" }}>01530 382 234</b> 
          </p>
          <p className="mt-4">
            <b>Thank You!</b>
          </p>
        </div>
        <div className="">
          <img
            className="w-[460px] h-[330px]"
            src={SentPageSvg}
            alt="SentPage"
          />
        </div>
        {/* <div className="mt-[-40px]">
          <img className="w-[100%]" src={Text} alt="Text"></img>
        </div> */}
        {/* <div className="flex gap-6">
          <p
            className="text-[25px] text-[#04595a]"
            style={{ fontFamily: "AmalfiCoast" }}
          >
            Collection Creator
          </p>
          <div className="text-[19px] text-[#616160] flex gap-6">
            <div className="flex gap-2">
              <p>P</p>
              <p>A</p>
              <p>C</p>
              <p>K</p>
              <p>A</p>
              <p>G</p>
              <p>I</p>
              <p>N</p>
              <p>G</p>
            </div>
            <div className="flex gap-2">
              <p>D</p>
              <p>E</p>
              <p>S</p>
              <p>I</p>
              <p>G</p>
              <p>N</p>
              <p>E</p>
              <p>D</p>
            </div>
            <div className="flex gap-2">
              <p>B</p>
              <p>Y</p>
            </div>
          </div>
          <p
            className="text-[25px] text-[#04595a]"
            style={{ fontFamily: "AmalfiCoast" }}
          >
            You!
          </p>
        </div> */}
          <div className="mt-[-40px]">
            <img className="w-[700px] mt-3.5" src={img} alt="logo"></img>
          </div>
      </div>
    </div>
  );
};

export default SentPage;
